import { render, staticRenderFns } from "./cascader.vue?vue&type=template&id=0ed79db1&scoped=true"
import script from "./cascader.vue?vue&type=script&lang=js"
export * from "./cascader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ed79db1",
  null
  
)

component.options.__file = "cascader.vue"
export default component.exports